'use client';

import { c as _c } from "react/compiler-runtime";
import type { File } from '@/types/github';
import type { ReactNode } from 'react';
import { createContext, use, useEffect, useState } from 'react';
export type PrV2FileFilterSnapshot = {
  files: File[];
  revealedFilenames: readonly string[];
  status: 'loading' | 'error' | 'ready';
};
const SnapshotContext = createContext<PrV2FileFilterSnapshot | null>(null);
const PublishContext = createContext<(snapshot: PrV2FileFilterSnapshot | null) => void>(() => {});

// Scoped to the mounted PR; derived file data must never go into persisted preferences.
export function PrV2FileFilterProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [snapshot, setSnapshot] = useState(null);
  let t1;
  if ($[0] !== children || $[1] !== snapshot) {
    t1 = <PublishContext value={setSnapshot}><SnapshotContext value={snapshot}>{children}</SnapshotContext></PublishContext>;
    $[0] = children;
    $[1] = snapshot;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function usePrV2FileFilterSnapshot() {
  return use(SnapshotContext);
}
export function usePublishPrV2FileFilterSnapshot(snapshot) {
  const $ = _c(6);
  const publish = use(PublishContext);
  const {
    files,
    revealedFilenames,
    status
  } = snapshot;
  let t0;
  let t1;
  if ($[0] !== files || $[1] !== publish || $[2] !== revealedFilenames || $[3] !== status) {
    t0 = () => {
      publish({
        files,
        revealedFilenames,
        status
      });
      return () => publish(null);
    };
    t1 = [files, publish, revealedFilenames, status];
    $[0] = files;
    $[1] = publish;
    $[2] = revealedFilenames;
    $[3] = status;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
}